import { Link } from "react-router-dom";

export default function BonPlansWeb({ promoProducts }) {
  const formatPriceDT = (value) => {
    const isWhole = Number(value) % 1 === 0;
    return `${new Intl.NumberFormat("fr-FR", {
      minimumFractionDigits: isWhole ? 0 : 3,
      maximumFractionDigits: 3,
    }).format(value)} DT`;
  };

  const getPromoLabel = (product) => {
    if (product.promo_type === "exact" || !product.promo_percentage) {
      // Calculate percentage from displayPrice and discountedPrice
      if (product.displayPrice && product.discountedPrice && product.displayPrice > 0) {
        const pct = Math.round(
          ((product.displayPrice - product.discountedPrice) / product.displayPrice) * 100
        );
        return pct > 0 ? `-${pct}%` : "Promo";
      }
      return "Promo";
    }
    return `-${product.promo_percentage}%`;
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        {promoProducts.map((product) => {
          // Parse categories
          let categories = [];
          try {
            if (typeof product.category === "string") {
              categories = JSON.parse(product.category);
            } else if (Array.isArray(product.category)) {
              categories = product.category;
            } else if (product.category) {
              categories = [product.category];
            }
            if (!Array.isArray(categories)) categories = [categories];
          } catch {
            categories = product.category ? [product.category] : [];
          }

          return (
            <div
              key={`${product.type}-${product.id}`}
              className="col-12 col-sm-6 col-md-4 mb-4"
            >
              <Link
                to={`/shop-details/${product.id}`}
                className="text-decoration-none"
              >
                <div
                  className="card border-0 shadow-sm rounded-4 h-100"
                  style={{
                    minHeight: "480px",
                    transition: "transform .3s ease, box-shadow .3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.03)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 30px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 15px rgba(0,0,0,0.1)";
                  }}
                >
                  {/* IMAGE */}
                  <div
                    className="position-relative overflow-hidden rounded-top"
                    style={{
                      height: "200px",
                      background: "#ffffff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "10px",
                    }}
                  >
                    <img
                      src={product.image}
                      alt={product.name}
                      className="img-fluid"
                      style={{
                        maxHeight: "180px",
                        objectFit: "contain",
                      }}
                    />

                    {/* PROMO BADGE — works for both exact and percentage */}
                    <span
                      className="position-absolute top-2 end-2 px-2 py-1 rounded-pill text-white fw-bold"
                      style={{
                        backgroundColor: "#81d9ff",
                        fontSize: "0.8rem",
                        boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
                      }}
                    >
                      {getPromoLabel(product)}
                    </span>
                  </div>

                  {/* CONTENT */}
                  <div className="card-body text-center d-flex flex-column">
                    {/* CATEGORIES */}
                    <div className="d-flex flex-wrap justify-content-center gap-1 mb-2">
                      {categories.map((cat, i) => (
                        <span
                          key={i}
                          className="px-2 py-1 rounded-pill"
                          style={{
                            backgroundColor: "#f1f8e9",
                            color: "#558b2f",
                            fontSize: "0.7rem",
                            fontWeight: "600",
                          }}
                        >
                          {cat}
                        </span>
                      ))}
                    </div>

                    {/* TITLE */}
                    <h5
                      className="fw-bold text-dark"
                      style={{
                        fontSize: "1.05rem",
                        minHeight: "48px",
                      }}
                    >
                      {product.name}
                      {product.type === "variation" && (
                        <span
                          className="d-block text-muted"
                          style={{
                            fontSize: "0.85rem",
                            fontWeight: "normal",
                          }}
                        >
                          {product.variation_name}
                        </span>
                      )}
                    </h5>

                    {/* PRICE */}
                    <div className="mt-3">
                      <div
                        className="badge text-white fw-bold mb-1"
                        style={{
                          backgroundColor: "#ff1fb2",
                          padding: "4px 10px",
                          borderRadius: "6px",
                          fontSize: "0.75rem",
                        }}
                      >
                        En Promotion
                      </div>

                      {/* Original price struck through */}
                      <div
                        className="fw-bold text-muted"
                        style={{
                          textDecoration: "line-through",
                          fontSize: "0.9rem",
                        }}
                      >
                        {formatPriceDT(product.displayPrice)}
                      </div>

                      {/* Final promo price */}
                      <div
                        className="fw-bold"
                        style={{
                          color: "#ff1fb2",
                          fontSize: "1.3rem",
                          fontWeight:600
                        }}
                      >
                        {formatPriceDT(product.discountedPrice)}
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}